import axios from 'axios';

export default {
    methods: {
        async precioIndex(d, ok, err) {
            try {
                let r = await axios.get('precio?page=' + d.page, {params: d});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioStore(d, ok, err) {
            try {
                let r = await axios.post('precio', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioUpdate(d, ok, err) {
            try {
                let r = await axios.put('precio/' + d.ident, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioDestroy(id, ok, err) {
            try {
                let r = await axios.delete('precio/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioDatos(ok, err) {
            try {
                let r = await axios.post('precio/datos');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioBusqueda(d, ok, err) {
            try {
                let r = await axios.post('precio/busqueda', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioInforme(ok, err) {
            try {
                let r = await axios.post('precio/informe');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioSolicitudIndex(d, ok, err) {
            try {
                let r = await axios.get('precio-solicitud?page=' + d.page, {params: d});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioSolicitudStore(d, ok, err) {
            try {
                let r = await axios.post('precio-solicitud', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioSolicitudDestroy(id, ok, err) {
            try {
                let r = await axios.delete('precio-solicitud/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioSolicitudPermiso(ok, err) {
            try {
                let r = await axios.post('precio-solicitud/permiso');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioSolicitudConfirma(id, ok, err) {
            try {
                let r = await axios.post('precio-solicitud/confirma', {id: id});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/precios.js